import { Injectable } from "@angular/core";
import { ApiService } from "@edp-services/api.service";

@Injectable({
    providedIn: "root",
})
export class RatingService {
    constructor(private apiService: ApiService) {}

    public getRatingStatus() {
        return this.apiService.callServicePostToCollection(`rating.check`, {});
    }

    public submitRating(args) {
        return this.apiService.callServicePostToCollection(`rating.save`, args);
    }
}
